import { COMMON_ROUTE } from "@obg/ngx.common";

export const TERMS_AND_CONDITIONS_ROUTES = [
	COMMON_ROUTE.termsAndConditions.root,
	COMMON_ROUTE.termsAndConditions.history,
];
